export default {
  admin: 'admin',
  'super-admin': 'super-admin',
  associate: 'associate',
  intern: 'intern',
};
